<template>
  <v-autocomplete
    v-model="model"
    outline

    color="secondary"
    :label="required ? '*' + label : label"
    :hint="hint"
    :error-messages="errorMessages"
    :loading="dataLoading"

    :name="fieldKey"
    :items="dataItems"
    :item-text="itemText"

    :item-value="itemValue"

    :disabled="disabled"
  >
    <!-- 見つからない場合 -->
    <template #no-data>
      <v-layout
        v-show="!ui.loading"
        justify-center
        class="text-grey py-3"
      >
        {{ $t('NoItems') }}
      </v-layout>
    </template>
  </v-autocomplete>
</template>

<script>
  import SelectItemMixin from './SelectItemMixin'

  export default {
    mixins: [SelectItemMixin],
    props: {
      modelValue: {
        type: Number,
        default: null
      }
    }
  }
</script>
